module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleMenu":{"ariaLabel":"Kategorie článků","title":"Kategorie článků"}},"de":{"ArticleMenu":{"ariaLabel":"Kategorien von Artikeln","title":"Kategorien von Artikeln"}},"sk":{"ArticleMenu":{"ariaLabel":"Kategórie článkov","title":"Kategórie článkov"}}}')
  delete Component.options._Ctor
}
